import TextareaAutosize from 'react-textarea-autosize';
import styled, { css } from 'styled-components';
import { ICustomThemeInput } from '../HBTextField/HBTextField.types';
import { customFont } from '../../styles/fonts';
import { fontSize, TTextFieldSize } from '../HBTextField/variables';
import { vars } from '../../theme';

function getThemeStyles(
    customTheme: ICustomThemeInput,
    size: TTextFieldSize = 'md'
) {
    if (customTheme) {
        const {
            fontFamily,
            fontColor = vars.colors.text.primary,
            fontWeight,
            padding,
            minHeight
        } = customTheme;

        return css`
            ::placeholder {
                color: ${fontColor};
                opacity: 0.6;
            }

            color: ${fontColor};
            font-family: ${customFont[fontFamily]?.font_family ||
            fontFamily ||
            `inherit`};
            font-size: ${fontSize[size].fontSize};
            font-weight: ${fontWeight};
            padding: ${padding};
            min-height: ${minHeight};
        `;
    }

    return null;
}

export const StyledTextareaAutosize = styled(TextareaAutosize)<{
    $customTheme: ICustomThemeInput;
    fontSize: TTextFieldSize;
}>`
    font-family: ${vars.fonts.body};
    display: flex;
    align-items: center;
    font-size: 18px;
    background-color: ${vars.colors.surface.itemInset};
    padding: 12px;
    border-color: transparent;
    border-radius: ${vars.radius.xs};
    color: ${vars.colors.text.primary};
    outline: none;
    height: unset;
    resize: none;
    min-height: unset;
    cursor: text;
    ${props => getThemeStyles(props.$customTheme, props.fontSize)}
    &:focus {
        background-color: ${vars.colors.surface.itemInsetHover};
    }
`;
